import React, { useEffect, useState } from "react";
import Card from "./card";
import CustomTitle from "@/component/custom-title";
import Carousel from "@/bit/components/components.carousel";
import useDeviceKind from "@gcloud-npm/utils.common.get-device-kind-depends-on-viewport";

const DigitalServiceCard = (props) => {
  const [isDeskTop, setIsDesktop] = useState();
  const device = useDeviceKind();

  useEffect(() => {
    handleReziceDevice();
    handleResizeTitle();
    handleResizeDescription();
  }, []);

  const handleReziceDevice = () => {
    if (device === "DESKTOP" || device === "BIG_DESKTOP") {
      setIsDesktop(true);
    } else {
      setIsDesktop(false);
    }
  };

  const handleResizeTitle = () => {
    const allTitles = document.querySelectorAll(".custom-height-title");
    for (var i = 0; i < allTitles.length; i += 4) {
      var grupoActual = [];
      // Construir el grupo actual de cuatro elementos
      for (var j = i; j < i + 4 && j < allTitles.length; j++) {
        grupoActual.push(allTitles[j]);
      }
      if (grupoActual.some((item) => item.offsetHeight === 36)) {
        grupoActual.forEach((item) => {
          item.style.height = "45px";
        });
      }
    }
  };

  const handleResizeDescription = () => {
    const allTitles = document.querySelectorAll(".card-item-height");
    for (var i = 0; i < allTitles.length; i += 4) {
      var grupoActual = [];
      // Construir el grupo actual de cuatro elementos
      for (var j = i; j < i + 4 && j < allTitles.length; j++) {
        grupoActual.push(allTitles[j]);
      }
      if (
        grupoActual.some(
          (item) =>
            item.querySelector(".custom-height-description").offsetHeight === 19
        )
      ) {
        grupoActual.forEach((item) => {
          item.style.minHeight = "485px";
        });
      }
    }
  };

  return (
    <div className="card-container container">
      <div className="card-content">
        {isDeskTop
          ? props["Content"].map((row, i) => {
              const categories = Object.keys(row);
              const priority = i === 0;
              return categories.map((categorieKey, i) => {
                const categoryContent = row[categorieKey];
                const title = categoryContent["Text-0"];
                const titleLink = categoryContent["CustomLink-2"];
                const cards = categoryContent.items;
                return (
                  <div
                    className={`card-and-title-content ${title.text.toLowerCase()} n${
                      cards.length > 4 ? 4 : cards.length
                    }`}
                    key={`item-${i}`}
                  >
                    {title && (
                      <div className="card-title-template">
                        <CustomTitle
                          title={title}
                          background={title.color}
                          link={titleLink}
                        />
                      </div>
                    )}
                    <div className="card-template">
                      <Carousel
                        className="service-card-content"
                        slideSeparation={24}
                        maxPointNum={0}
                        breakpoint={10000}
                      >
                        {cards.map((card, index) => {
                          return (
                            <div
                              className="card-item card-item-height"
                              key={`service-card-${index}`}
                            >
                              <Card
                                {...card}
                                index={index}
                                setPriority={priority}
                              ></Card>
                            </div>
                          );
                        })}
                      </Carousel>
                    </div>
                  </div>
                );
              });
            })
          : props["ContentMobile"].map((row, i) => {
              const categories = Object.keys(row);
              const priority = i === 0;

              return categories.map((categorieKey, i) => {
                const categoryContent = row[categorieKey];
                const title = categoryContent["Text-0"];
                const titleLink = categoryContent["CustomLink-2"];
                const cards = categoryContent.items;
                return (
                  <div
                    className={`card-and-title-content ${title.text.toLowerCase()} n${
                      cards.length > 4 ? 4 : cards.length
                    }`}
                    key={`item-${i}`}
                  >
                    {title && (
                      <div className="card-title-template">
                        <CustomTitle
                          title={title}
                          background={title.color}
                          link={titleLink}
                        />
                      </div>
                    )}
                    <div className="card-template">
                      <Carousel
                        className="service-card-content"
                        maxPointNum={0}
                        breakpoint={768}
                      >
                        {cards.map((card, index) => {
                          return (
                            <div
                              className="card-item card-item-height"
                              key={`service-card-${index}`}
                            >
                              <Card
                                {...card}
                                index={index}
                                setPriority={priority}
                              ></Card>
                            </div>
                          );
                        })}
                      </Carousel>
                    </div>
                  </div>
                );
              });
            })}
      </div>

      <style jsx>
        {`
          .card-container {
            margin-top: 1rem;
            margin-bottom: 1rem;
            display: flex;
            flex-direction: column;

            .card-content {
              flex-wrap: wrap;
              display: flex;
              gap: 24px;

              .card-and-title-content {
                width: 100%;
                .card-template {
                  margin-bottom: 1rem;
                  min-height: 90%;

                  :global(.carousel) {
                    height: 100%;
                    :global(.content-container) {
                      height: 100%;
                      :global(.carousel-window) {
                        gap: 24px;
                        height: 100%;
                        @media screen and (max-width: 768px) {
                          gap: 12px;
                        }
                        :global(.carousel-item-wrapper) {
                          width: min-content;
                          padding: 0;
                        }
                      }
                    }
                  }
                  .service-card-content {
                    display: inline-flex;
                    flex-direction: row;
                    gap: 24px;
                    width: 100%;

                    &::-webkit-scrollbar {
                      display: none;
                    }
                  }

                  &::-webkit-scrollbar {
                    display: none;
                  }

                  :global(.card-clickable) {
                    &:focus {
                      border-radius: 16px;
                    }
                  }

                  .card-item {
                    display: flex;
                    width: min(20.7vw, 348px);
                    height: 100%;
                  }
                }
              }
            }

            @media screen and (max-width: 1536px) {
              .card-content {
                .card-and-title-content {
                  .card-template {
                    .card-item {
                      width: min(21.9vw, 316px);
                    }
                  }
                }
              }
            }

            @media screen and (max-width: 1448px) {
              .card-content {
                .card-and-title-content {
                  .card-template {
                    &.n2 {
                      justify-content: flex-start;
                    }
                    &.n3 {
                      justify-content: flex-start;
                    }
                    .card-item {
                      width: min(21.7vw, 317px);
                    }
                  }
                }
              }
            }

            @media screen and (max-width: 1290px) {
              .card-content {
                gap: 24px;
                .card-and-title-content {
                  &.n4 {
                    width: 100%;
                  }
                  &.n3 {
                    width: 100%;
                  }
                  &.n2 {
                    width: 100%;
                  }
                  &.n1 {
                    width: 100%;
                  }
                  .card-template {
                    &.n2 {
                      width: 100%;
                      flex-wrap: nowrap;
                    }
                    .card-item {
                      width: 300px;
                    }
                  }
                }
              }
            }
            @media screen and (max-width: 768px) {
              .card-content {
                .card-and-title-content {
                  .card-template {
                    gap: 12px;
                    .card-item {
                      display: grid;
                      width: 300px;
                      min-height: 520px;
                    }
                  }
                }
              }
            }
            @media screen and (max-width: 1292px) {
              .card-content {
                .card-and-title-content {
                  &.seguros.n1 {
                    width: 27%;
                  }
                  &.seguros.n2 {
                    width: 70%;
                  }
                }
              }
            }
            @media screen and (min-width: 1292px) {
              .card-content {
                .card-and-title-content {
                  &.n4 {
                    width: 100%;
                  }
                  &.n3 {
                    width: 74%;
                  }
                  &.n2 {
                    width: 49%;
                  }
                  &.n1 {
                    width: 23.5%;
                  }
                  .card-template {
                    display: flex;
                    overflow-x: auto;
                    overflow-y: hidden;
                    &.n1 {
                      justify-content: right;
                    }
                  }
                }
              }
            }
          }
        `}
      </style>
    </div>
  );
};

export default DigitalServiceCard;
